import { useSelector } from "react-redux";
import { RootState } from "../store";

export const useRoleAuthorization = (allowedRoles: string[]): boolean => {
  const { currentUser } = useSelector((state: RootState) => state.user);
  const currentRole = currentUser?.userRole?.name;

  const isAuthorized = Boolean(
    currentRole && allowedRoles.includes(currentRole)
  );

  return isAuthorized;
};